import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/LanguageContext";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Portfolio from "@/components/sections/Portfolio";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App relative bg-[#0B0C10] text-[#EDEDED] font-body">
        <Header />
        <main>
          <Hero />
          <Services />
          <Process />
          <Portfolio />
          <Testimonials />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#14161A",
              color: "#EDEDED",
              border: "1px solid #2C2F36",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
